import { ActualsValueTypes } from '../actualValueTypes'

// Default Section Settings Keys
// Old key 'jbp-partner-actuals-value-type-net{-offering}'
export const JBP_EXPORT_PLAN_ACTUALS_VALUE_TYPE_KEY = 'jbp-export-plan-actuals-value-type'

// Default Section Settings Values
export const JBP_EXPORT_PLAN_ACTUALS_VALUE_TYPE_RETAIL_DEFAULT = ActualsValueTypes.Ndp
export const JBP_EXPORT_PLAN_ACTUALS_VALUE_TYPE_DISTRIBUTOR_DEFAULT = ActualsValueTypes.TNet
